import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './components/Errors/ErrorBoundary';
import { AuthProvider } from './helpers/authContext';
import { AppProvider } from './helpers/appContext';

const root = document.getElementById('root');
ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
    <AuthProvider>
      <AppProvider>
        <App />
      </AppProvider>
    </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>,
  root
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
